import React from 'react'
import PropTypes from "prop-types"
import {FormatUtcDateAsLocal} from '../../../../../../helpers/datetime'
import * as Badges from '../../../../../../components/badges'

const PoolRiskLevelChanged = (props) => {
  
  const payload = JSON.parse(props.item.payload)
  const { RiskLevel } = payload
  const data = `Pool risk level change to ${RiskLevel}`

  return <tr>
    <td><Badges.PoolRiskLevelChanged/></td>
    <td>{data}</td>
    <td>{FormatUtcDateAsLocal(props.item.createdUtc)}</td>
    <td>{props.item.createdBy}</td>
  </tr>
}

PoolRiskLevelChanged.propTypes = {
  item: PropTypes.object
}

export default PoolRiskLevelChanged



// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/poolRiskLevelChanged/index.js